///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2026
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import messages from "./messages";

export const formatHasMatches = value => {
  if (value === true || value === "true") {
    return messages.hasMatches.defaultMessage;
  }
  if (
    value === false ||
    value === "false" ||
    value === undefined ||
    value === null
  ) {
    return messages.noMatches.defaultMessage;
  }
  return value;
};

export default formatHasMatches;
